var map = {
	"./ContainerMountPaths.vue": 57570,
	"./Mount.vue": 65882,
	"./awsElasticBlockStore.vue": 53880,
	"./azureDisk.vue": 5989,
	"./azureFile.vue": 2800,
	"./emptyDir.vue": 45343,
	"./gcePersistentDisk.vue": 62429,
	"./hostPath.vue": 45277,
	"./index.vue": 97749,
	"./nfs.vue": 12011,
	"./secret.vue": 84761,
	"./vsphereVolume.vue": 39193,
	"edit/workload/storage/ContainerMountPaths.vue": 57570,
	"edit/workload/storage/Mount.vue": 65882,
	"edit/workload/storage/awsElasticBlockStore.vue": 53880,
	"edit/workload/storage/azureDisk.vue": 5989,
	"edit/workload/storage/azureFile.vue": 2800,
	"edit/workload/storage/emptyDir.vue": 45343,
	"edit/workload/storage/gcePersistentDisk.vue": 62429,
	"edit/workload/storage/hostPath.vue": 45277,
	"edit/workload/storage/index.vue": 97749,
	"edit/workload/storage/nfs.vue": 12011,
	"edit/workload/storage/secret.vue": 84761,
	"edit/workload/storage/vsphereVolume.vue": 39193
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68219;